import { ExamPaperSetting } from './ExamPaperSetting';
export default ExamPaperSetting;